var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.goods ? _vm.goods.name : "选择规格",
        footer: null,
        width: "420px",
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "spec-list" },
        _vm._l(_vm.units, function (unit) {
          return _c(
            "div",
            {
              key: unit.extendId,
              staticClass: "spec-row",
              on: {
                click: function ($event) {
                  return _vm.pick(unit)
                },
              },
            },
            [
              _c("div", { staticClass: "spec-info" }, [
                _c("div", { staticClass: "spec-unit" }, [
                  _vm._v("\n          " + _vm._s(unit.unit) + "\n          "),
                  unit.sku
                    ? _c("span", { staticClass: "spec-sku" }, [
                        _vm._v(_vm._s(unit.sku)),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "spec-barcode" }, [
                  _vm._v(_vm._s(unit.barCode)),
                ]),
              ]),
              _c("div", { staticClass: "spec-price" }, [
                _c(
                  "span",
                  { class: { "price-member": _vm.isMemberPrice(unit) } },
                  [_vm._v("¥" + _vm._s(_vm.format(unit.price)))]
                ),
                _vm.isMemberPrice(unit)
                  ? _c("span", { staticClass: "price-origin" }, [
                      _vm._v("¥" + _vm._s(_vm.format(unit.retailPrice))),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }